import { useEffect } from 'react';
import type { FlowId } from '../../types';

interface FlowSyncOptions {
  flowId: FlowId;
  resolvedFlowId: FlowId;
  setFlowId: (flowId: FlowId) => void;
}

export const useFlowSync = ({ flowId, resolvedFlowId, setFlowId }: FlowSyncOptions): void => {
  useEffect(() => {
    if (flowId !== resolvedFlowId) {
      setFlowId(resolvedFlowId);
    }
  }, [flowId, resolvedFlowId, setFlowId]);
};
